import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-redirect",
    templateUrl: "./redirect.component.html",
    styleUrls: ["./redirect.component.scss"]
})
export class RedirectComponent implements OnInit {
    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        // Get the current route path to determine redirect URL
        const currentPath = this.route.snapshot.routeConfig?.path;
        
        let redirectUrl = "https://health-ecomm.com/gsk/slide-hub-wip/index.html"; // default
        
        // Handle specific redirects based on path
        if (currentPath === "landingpage/onko-campus-hcp") {
            redirectUrl = "https://event.on24.com/wcc/r/5217417/BAFA6716F105A0414D11C88E0E51A326";
        } else if (currentPath === "landingpage/onko-campus-mfa") {
            redirectUrl = "https://event.on24.com/wcc/r/5240857/32C149C9B83B37A099AF9DC825B1D733";
        }
        
        window.location.href = redirectUrl;
    }
}
